import gql from 'graphql-tag';

import { UserDetails } from '../fragments/account';
import { AlbumFolderPrintAssetDetails } from '../fragments/album-folder';

export const HierarchyItem = gql`
  query hierarchyItem($id: RecordID!, $forAccountProfile: Boolean = false) {
    hierarchyItem(id: $id, for_account_profile: $forAccountProfile) {
      ... on IHierarchyItem {
        id
        item_type
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          name
          album_type
          album_subtype
          account {
            id
          }
          root {
            id
          }
        }
        albums(include_nested_albums: true, slice: { limit: 999 }) {
          records {
            id
            name
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          name
          album_type
          album_subtype
          creator {
            id
          }
          root_album_folder {
            id
          }
        }
      }
    }
  }
`;

export const HierarchyTransfer = gql`
  query hierarchyTransfer($hierarchy_item_id: RecordID!) {
    hierarchyTransfer(hierarchy_item_id: $hierarchy_item_id) {
      id
      source_account {
        ...UserDetails
      }
      album_folder {
        id
        purchased_event {
          id
          name
        }
      }
    }
  }
  ${UserDetails}
`;

export const HierarchyItemForTypeCheck = gql`
  query HierarchyItemForTypeCheck($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on IHierarchyItem {
        id
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          root {
            id
            prepaid_custom_prints_enabled
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          root_album_folder {
            id
            prepaid_custom_prints_enabled
          }
        }
      }
    }
  }
`;

export const HierarchyItemForFavorites = gql`
  query hierarchyItemForFavorites($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on IHierarchyItem {
        id
        item_type
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          account_favorite_photos {
            total
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          is_video_album
          account_favorite_photos {
            total
          }
        }
      }
    }
  }
`;

export const HierarchyItemForPrintAssets = gql`
  query hierarchyItemForPrintAssets($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on IHierarchyItem {
        id
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          root {
            id
            ...AlbumFolderPrintAssetDetails
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          root_album_folder {
            ...AlbumFolderPrintAssetDetails
          }
        }
      }
    }
  }
  ${AlbumFolderPrintAssetDetails}
`;

export const HierarchyItemHierarchyBreadcrumb = gql`
  query hierarchyItemHierarchyBreadcrumb(
    $id: RecordID!
    $for_web_gallery: Boolean = false
    $use_all_photos_mode: Boolean = false
  ) {
    hierarchyItem(id: $id) {
      ... on HierarchyAlbumFolderItem {
        id
        album_folder {
          id
          name
          is_owner
          picture_day_enabled
          individual_albums
          album_type
          account {
            id
          }
          joins_enabled
          matching_disabled
          account_hierarchy_settings {
            id
            notifications_enabled
          }
          children {
            albums(slice: { limit: 1 }) {
              records {
                id
              }
            }
            album_folders(slice: { limit: 1 }) {
              records {
                id
              }
            }
          }
          album_folder_hierarchy {
            records {
              id
              name
              individual_albums
              contributor_access {
                upload_access
                view_access
                album_create_access
                invite_enabled
              }
            }
          }
          account_favorite_photos {
            total
          }
          photos {
            total
          }
          videos(processed_only: false) {
            total
          }
        }
      }
      ... on HierarchyAlbumItem {
        id
        album {
          id
          name
          is_owner
          picture_day_enabled
          is_video_album
          is_wedding_day_album
          is_memory_book
          is_reference_photos_album
          album_type
          has_all_photos_access(
            for_web_gallery: $for_web_gallery
            use_all_photos_mode: $use_all_photos_mode
          )
          account_hierarchy_settings {
            id
            notifications_enabled
          }
          creator {
            id
          }
          album_folder {
            id
            individual_albums
          }
          root_album_folder {
            id
            individual_albums
            matching_disabled
          }
          album_folder_hierarchy {
            records {
              id
              name
              contributor_access {
                upload_access
                view_access
                album_create_access
                invite_enabled
              }
            }
          }
          photos(include_unprocessed: true) {
            total
          }
          videos(processed_only: false) {
            total
          }
          slideshow {
            status
          }
          joins_enabled
          matching_disabled
          purchased_event_addon_types
          account_favorite_photos {
            total
          }
        }
      }
    }
  }
`;

export const HierarchyItemForOwnerPurchaseJoins = gql`
  query hierarchyItemForOwnerPurchaseJoins($id: RecordID!) {
    hierarchyItem(id: $id) {
      ... on IHierarchyItem {
        id
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          name
          album_type
          album_subtype
          owner_purchased_joins_enabled
          price {
            value
          }
          account {
            id
          }
          root {
            id
          }
        }
        albums(include_nested_albums: true, slice: { limit: 999 }) {
          records {
            id
            name
            price_whole_album {
              value
            }
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          name
          album_type
          album_subtype
          owner_purchased_joins_enabled
          price_whole_album {
            value
          }
          creator {
            id
          }
          root_album_folder {
            id
          }
        }
      }
    }
  }
`;
